import { type GridFactory, Grid as MantineGrid } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./grid.module.scss";
import type { IProps } from "./grid.types";

const Grid = componentWrapper<GridFactory, IProps>("Grid", (props, ref) => {
    return <MantineGrid ref={ref} classNames={{ root: styles["container"] }} {...props} />;
});

Grid.Col = MantineGrid.Col;

export { Grid };
